var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_173141",
    "data-name": "Group 173141",
    transform: "translate(-989 -264)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3247",
    "data-name": "Ellipse 3247",
    cx: 20.5,
    cy: 20.5,
    r: 20.5,
    transform: "translate(989 264)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_65c8c757d1129e3265462e2b6a129f89",
    "data-name": "65c8c757d1129e3265462e2b6a129f89",
    transform: "translate(951.95 181.154)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_168907",
    "data-name": "Path 168907",
    d: "M65.556,98.341h-3.1L60.6,96.468s-.009-.009-.014-.009l-.009-.009A1.5,1.5,0,0,0,59.51,96H55.653a1.518,1.518,0,0,0-1.129.5v0l-1.813,1.836H49.543A1.525,1.525,0,0,0,48,99.866v9.279a1.544,1.544,0,0,0,1.543,1.547H65.556a1.547,1.547,0,0,0,1.543-1.547V99.866A1.527,1.527,0,0,0,65.556,98.341ZM57.55,108.373a4.251,4.251,0,1,1,4.242-4.251A4.255,4.255,0,0,1,57.55,108.373Zm7.718-7.575a.647.647,0,1,1,.643-.647A.646.646,0,0,1,65.267,100.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168908",
    "data-name": "Path 168908",
    d: "M189.4,202.9a3.214,3.214,0,1,0,3.2,3.214A3.207,3.207,0,0,0,189.4,202.9Z",
    transform: "translate(-131.855 -101.992)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.83d8308f058d53e18a8cade7a2ad83c0.svg";
export { ForwardRef as ReactComponent };